import { useRouter } from 'next/router'
import NProgress from 'nprogress'
import { useEffect } from 'react'

/**
 * Integrates NProgress with Next.js router events to show a loading bar
 * during route transitions.
 */
export const useRouterProgress = () => {
    const router = useRouter()

    useEffect(() => {
        // Memory leak fix: use stable function references so .off() actually removes them
        const onStart = () => NProgress.start()
        const onDone = () => NProgress.done()

        router.events.on('routeChangeStart', onStart)
        router.events.on('routeChangeComplete', onDone)
        router.events.on('routeChangeError', onDone)

        return () => {
            router.events.off('routeChangeStart', onStart)
            router.events.off('routeChangeComplete', onDone)
            router.events.off('routeChangeError', onDone)
        }
    }, [router])
}
